<template>
  <div>

    <base-header class="pb-6 bg-light">

      <b-row align-v="center" class="py-4">
        <b-col cols="12"  md="7"  lg="6">
          <h6 class="h2 d-inline-block mb-0 text-dark">OTA Profile Info</h6> &nbsp;
          <span v-if="isEditor||isAdministrator">
            <base-button  type="primary" size="sm"  :disabled="iccid.length === 0" v-on:click="clickActivate">Activate</base-button>
          </span>
          &nbsp;
          <span v-if="isEditor||isAdministrator">
            <base-button  type="danger" size="sm"  :disabled="iccid.length === 0" v-on:click="clickReset" >Reset</base-button>
          </span>
        </b-col>
        <b-col cols="12" md="5" lg="6" class="text-right">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>

      <div v-if="noAccess">
        <b-card>
          <b-card-header>
            <p class="h2 mb-2">
              <b-icon-exclamation-triangle-fill variant="danger"></b-icon-exclamation-triangle-fill>&nbsp;Restricted
            </p>
          </b-card-header>
          <b-card-body>Access is Restricted</b-card-body>
        </b-card>
      </div>
      <div v-else>

        <b-row>
          <b-col xl="6">
            <div class="input-group">
              <b-input-group>
                <template #prepend>
                  <b-input-group-text class="iccid-width ps">ICCID</b-input-group-text>
                </template>
                <b-form-input id="iccid" type="text" v-model="iccid"></b-form-input>
                <template #append>
                  <base-button size="lg" type="success" title="Search" v-on:click="getProfileData">
                    <i class="fa fa-search"></i>
                  </base-button>
                </template>
              </b-input-group>
            </div>
            <br>
          </b-col>
          <b-col xl="6"></b-col>
        </b-row>

        <b-row v-if="!hasData">
          <b-col xl="12">
            <b-card no-body>
              <b-card-body>
                <div align="center">Please enter a valid iccid that exists in the system.</div>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>

        <b-row v-if="hasData">
          <b-col xl="6">
            <b-card no-body>
              <b-card-body>
                <table class="table b-table">
                  <tr>
                    <th colspan="2" class="primary-table-header">
                      <div class="">Subscription Information</div>
                    </th>
                  </tr>
                </table>
                <div class="table-responsive">
                  <b-table id="log_table"
                           :items="sub_data"
                           :fields="sub_fields"
                           head-row-variant="light"
                           head-variant="light"
                           table-class="text-nowrap"
                           class="data-management-table second-table"
                           sticky-header="true"
                           thead-class="white"
                           responsive
                           small
                  >
                    <template #cell(data_name)="row">
                      {{ row.item.data_name }}
                    </template>
                    <template #cell(data_value)="row">
                      <span v-if="row.item.data_value.name" v-b-tooltip.hover
                            :title="'api_name: '+row.item.data_value.name">
                        {{ row.item.data_value.display_name }}
                        <b-badge variant="warning" v-if="row.item.data_value.default">Default</b-badge>
                      </span>
                      <span v-else>
                      {{ row.item.data_value }}
                      </span>
                    </template>
                  </b-table>
                </div>
              </b-card-body>
            </b-card>
          </b-col>
          <b-col xl="6">

            <b-card no-body>
              <b-card-body>
                <table class="table b-table">
                  <tr>
                    <th colspan="2" class="primary-table-header">
                      <div class="">HTTP OTA Information</div>
                    </th>
                  </tr>
                </table>
                <div class="table-responsive">
                  <b-table id="log_table"
                           :items="http_data"
                           :fields="keyval_fields"
                           head-row-variant="light"
                           head-variant="light"
                           table-class="text-nowrap"
                           class="data-management-table second-table"
                           sticky-header="true"
                           thead-class="white"
                           responsive
                           small
                  >
                  </b-table>
                </div>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>

        <b-row v-if="isPortalAdmin && hasData">
          <b-col xl="12">
            <b-card no-body>
              <b-card-body>
                <table class="table b-table">
                  <tr>
                    <th colspan="2" class="ps">
                      <div>
                        SIM keys
                        &nbsp;
                        <b-badge pill variant="danger">THIS SECTION IS ONLY VISIBLE TO DCC PORTAL ADMIN</b-badge>
                      </div>
                    </th>
                  </tr>
                </table>
                <div class="table-responsive">
                  <b-table id="log_table"
                           :items="key_data"
                           :fields="keyval_fields"
                           head-row-variant="light"
                           head-variant="light"
                           table-class="text-nowrap"
                           class="data-management-table second-table"
                           sticky-header="true"
                           thead-class="white"
                           responsive
                           small
                  >
                  </b-table>
                </div>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>

        <b-row v-if="hasData">
          <b-col xl="12">
            <b-card no-body>
              <b-card-body>
                <!--LOG ITEMS: log_items
                https://stackoverflow.com/questions/67354006/b-table-items-for-deeply-nested-arrays
                -->
                <table class="table b-table">
                  <tr>
                    <th colspan="2" class="primary-table-header">
                      <div class="">OTA Records </div>
                    </th>
                  </tr>
                </table>
                <div class="">
                  <b-table id="log_table"
                           :items="log_data"
                           :fields="log_items_fields"
                           head-row-variant="light"
                           head-variant="light"
                           table-class="text-nowrap"
                           class="data-management-table second-table"
                           sticky-header="true"
                           thead-class="white"
                           responsive
                           small
                  >
                    <template #cell(date)="row">
                      <span class="nowrap">
                        {{ row.item.date }}
                      </span>
                    </template>
                    <template #cell(ota)="row">
                      <base-button size="sm" :type="formatSuccess(row.item.ota)" class="nowrap">
                        {{ row.item.ota }}
                      </base-button>
                    </template>
                    <template #cell(smsota)="row">
                      {{ row.item.smsota }}
                    </template>
                    <template #cell(username)="row">
                      {{ row.item.username }}
                    </template>
                    <template #cell(items)="row">
                      <base-button @click="row.toggleDetails()" type="primary" size="sm" style="width:100px;" class="nowrap">Details
                      </base-button>
                    </template>
                    <template v-slot:row-details="row">
                      <table class="under-table">
                        <tbody>
                        <tr v-for="(value, key) in row.item" :key="key">
                          <td
                              v-if="key!=='date' && key!=='_showDetails' && key!=='username' && key!=='items' && key!=='smsota' && key!=='ota'">
                            <b>{{ key }}</b>
                          </td>
                          <td
                              v-if="key!=='date' && key!=='_showDetails' && key!=='username' && key!=='items' && key!=='smsota' && key!=='ota'">
                            {{ formatObjectData(value) }}
                          </td>
                        </tr>
                        <tr v-for="(value, key) in row.item.items" :key="key">
                          <td><b v-if="isNaN(key)">{{ key }}</b></td>
                          <td>
                            <span v-if="value.name">
                              {{ value.data }}  <b-badge variant="warning"
                                                         v-if="value.name==='default'">default</b-badge>
                            </span>
                            <span v-else>
                              {{ value }}
                            </span>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </template>
                  </b-table>
                </div>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>

      </div>
    </base-header>

    <!--    <b-modal id="fileInfoModel" v-model="showFileInfoModal" title="Message" centered>-->
    <!--      <div class="input-group" v-if="fileInfo">-->
    <!--        <b-input-group>-->
    <!--          <template #prepend>-->
    <!--            <b-card-body>-->
    <!--              <div>-->
    <!--                <Strong>API Name:</Strong>-->
    <!--                <span class="ml-1">{{ fileInfo.name || {} }}</span>-->
    <!--              </div>-->
    <!--              <div>-->
    <!--                <Strong>Size:</Strong>-->
    <!--                <span class="ml-1">{{ fileInfo.size || 0 }} B</span>-->
    <!--              </div>-->
    <!--              <div>-->
    <!--                <Strong>Modified:</Strong>-->
    <!--                <span class="ml-1">{{ fileInfo.date.modified || {} }}</span>-->
    <!--              </div>-->
    <!--              <div>-->
    <!--                <Strong>Disabled:</Strong>-->
    <!--                <span class="ml-1">{{ fileInfo.disabled === 1 ? "Yes" : "No" }}</span>-->
    <!--              </div>-->
    <!--            </b-card-body>-->
    <!--          </template>-->
    <!--        </b-input-group>-->
    <!--      </div>-->
    <!--    </b-modal>-->

  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import otaDashboardService from "@/common/api-services/ota-dashboard-service";
import initService from "@/common/api-services/init-service";
import ToastVue from '../../Components/Toast.vue';

export default {
  components: {
    RouteBreadCrumb,
    ToastVue
  },

  data() {
    return {
      showFileInfoModal: false,
      fileInfo: [],
      admin_style: 'background-color:rgba(255,87,51);color:#FFFFFF;width:150px',
      submitLoading: false,
      hasData: false,
      iccid: '',

      //profile list
      profile_data_src: [],
      http_data: [],
      sub_data: [],
      key_data: [],
      log_data: [],

      sub_fields: [
        {key: 'data_name', label: 'Template'},
        {key: 'data_value', label: 'Data'},
        //{key: 'data_type', label: 'Type'}
      ],

      keyval_fields: [
        {key: 'data_name', label: 'Name'},
        {key: 'data_value', label: 'Value'}
      ],

      //https://stackoverflow.com/questions/67354006/b-table-items-for-deeply-nested-arrays
      log_items_fields: [
        {key: 'date', sortable: true,},
        {key: 'username', sortable: true,},
        {key: 'ota', label: 'action', sortable: true,},
        //{key: 'smsota'},
        {key: 'items', label: 'details'},
      ],

      //ACCESS ROLES
      noAccess: true,
      isReadOnly: true,
      isEditor: false,
      isAdministrator: false,
      isPortalAdmin: false,
      progressTitle: null,
      progressMessage: null,
    }
  },

  mounted() {
    document.title = 'OTA - Profile';

    /** NOTE: The following needs to be in data:
     noAccess: true,
     isReadOnly: true,
     isEditor: false,
     isAdministrator: false,
     isPortalAdmin: false,
     */

    //The user needs to be notified that this is not accessible.
    this.noAccess = (
        !initService.getUserRoles().includes('Administrator') &&
        !initService.getUserRoles().includes('OTA_ADMIN') &&
        !initService.getUserRoles().includes('OTA_READ') &&
        !initService.getUserRoles().includes('OTA_EDIT')
    );

    //set the roles [isReadOnly, isEditor, isAdministrator, isPortalAdmin]
    this.isReadOnly = (initService.getUserRoles().includes('OTA_READ'));
    this.isEditor = (initService.getUserRoles().includes('OTA_EDIT'));
    this.isAdministrator = (initService.getUserRoles().includes('Administrator') || initService.getUserRoles().includes('OTA_ADMIN'));
    this.isPortalAdmin = (initService.getPortalAdminRole());

    //write to console.
    console.log('PAGE:', document.title)
    console.log('isReadOnly:', this.isReadOnly);
    console.log('isEditor:', this.isEditor);
    console.log('isAdministrator:', this.isAdministrator);
    console.log('isPortalAdmin:', this.isPortalAdmin);

    //don't do anything unless the user has access
    if (!this.noAccess) {
      if (this.$route.query.iccid!=='' && typeof this.$route.query.iccid !== 'undefined') this.iccid = this.$route.query.iccid;
      else this.readCache();
      //load page
      this.loadPageData();
    }

  },

  methods: {

    readCache() {
      //get the last saved filter criteria
      let search = localStorage.getItem(this.$route.name);
      console.log('reading search:', search);
      if (search) {
        search = JSON.parse(search);
        if (search.iccid && search.iccid !== '')
          this.iccid = search.iccid;
      }
    },

    writeCache() {
      //set to current filter criteria
      let search = {
        iccid: this.iccid,
      };
      console.log('writing search:', search);
      localStorage.setItem(this.$route.name, JSON.stringify(search));
    },

    formatSuccess(item) {
      item = `${item}`;
      if (item.toLowerCase().includes('success') || item.toLowerCase().includes('activated')) {
        return 'success';
      } else if (item.toLowerCase().includes('did not complete') || item.toLowerCase().includes('error')) {
        return 'danger';
      } else {
        return 'warning';
      }
    },

    getFileInfo(data) {

      //getInfo_API({carrier: carrier.name, name: val.name, type: val.type,});

      otaDashboardService
          .getCarrierFileInfo(data)
          .then(res => {
            this.showFileInfoModal = true;
            this.fileInfo = res.data.result;
          })
          .catch(err => {
            throw err;
          });
      this.fileInfo = null;
    },

    flattenValue(obj) {
      if (typeof obj === 'object' &&
          !Array.isArray(obj) &&
          obj !== null) {
        let val = '';
        Object.keys(obj).forEach(item => {
          val += item + ':' + obj[item] + ', ';
        });
        return val;
      } else {
        return obj;
      }
    },

    async loadPageData() {
      try {
        if (!this.iccid || this.iccid.length !== 20) {
          throw new Error('Invalid ICCID.');
        } else {
          this.getProfileData();
        }
      } catch (e) {
        //this.showToasterMsg('[loadPage]Error:' + e.message, true, 'danger');
      }
    },

    async getProfileData() {
      this.submitLoading = true;
      this.iccid = this.iccid.substring(0, 20);
      this.writeCache();

      await otaDashboardService.query(this.iccid, 0, 0).then(res => {
            if (res.data.status) {
              if (res.data.result) {
                // console.log(res.data.result);
                let http_data = [];
                let sub_data = [];
                let key_data = [];

                if (res.data.result.carrier.display_name)
                  sub_data.push({'data_name': 'Carrier', 'data_value': res.data.result.carrier.display_name});

                //keys table
                if (res.data.result.items.keys) {
                  Object.keys(res.data.result.items.keys).forEach(function (data_key) {
                    let data_val = '';
                    if (data_key === 'tls') {
                      if (initService.getPortalAdminRole()) {
                        data_val = res.data.result.items.keys[data_key];
                      } else {
                        //data_val = " *** data masked *** ";
                        data_val = String('').padStart(data_val.length, '*')
                      }
                      data_key = 'Tls Key';
                      key_data.push({'data_name': data_key, 'data_value': data_val});
                    } else if (data_key === 'kic') {
                      if (initService.getPortalAdminRole()) {
                        data_val = res.data.result.items.keys[data_key];
                      } else {
                        //data_val = " *** data masked ***";
                        data_val = String('').padStart(data_val.length, '*')
                      }
                      data_key = 'Kic Key';
                      key_data.push({'data_name': data_key, 'data_value': data_val});
                    } else if (data_key === 'kid') {
                      if (initService.getPortalAdminRole()) {
                        data_val = res.data.result.items.keys[data_key];
                      } else {
                        //data_val = " *** data masked ***";
                        data_val = String('').padStart(data_val.length, '*')
                      }
                      data_key = 'Kid Key';
                      key_data.push({'data_name': data_key, 'data_value': data_val});
                    } else if (data_key === 'vendor') {
                      data_val = res.data.result.items.keys[data_key];
                      switch (data_val) {
                        case 'simulitylte':
                          data_val = 'Simulity LTE';
                          break;
                        case 'simulity':
                          data_val = 'Simulity';
                          break;
                        case 'gemalto':
                          data_val = 'Gemalto';
                          break;
                        case 'esim':
                          data_val = 'ESIM';
                          break;
                        default:
                          data_val = 'Default (Simulity)';
                          break;
                      }
                      data_key = 'Vendor';
                      key_data.push({'data_name': data_key, 'data_value': data_val});
                    }
                  });
                }

                //http table
                Object.keys(res.data.result.items.data).forEach(function (data_key) {
                  let data_val = '';
                  let data_type = 'field';
                  if (data_key === 'state') {
                    data_val = res.data.result.items.data[data_key];
                    data_key = 'Provision State';
                    //0=complete, 1=provision, 2=testing, 3= PRL only, 4=Downloading.
                    switch (data_val) {
                      case '0':
                        data_val = 'Complete(0)';
                        break;
                      case '1':
                        data_val = 'Waiting(1)';
                        break;
                      case '2':
                        data_val = 'Testing(2)';
                        break;
                      case '3':
                        data_val = 'PRL only(3)';
                        break;
                      case '4':
                        data_val = 'Downloading(4)';
                        break;
                      default:
                        data_val = 'Active';
                        break;
                    }
                  } else if (data_key === 'lastotatime') {
                    data_val = res.data.result.items.data[data_key];
                    data_key = 'Last SIM Provision';
                    if (data_val === '') data_val = 'Never';
                  } else if (data_key === 'lastqueriedtime') {
                    data_val = res.data.result.items.data[data_key];
                    data_key = 'Last SIM Checkin';
                    if (data_val === '') data_val = 'Never';
                  } else if (data_key === 'lastupdatetime') {
                    data_val = res.data.result.items.data[data_key];
                    data_key = 'Last Record Updated';
                    if (data_val === '') data_val = 'Never';
                  } else if (data_key === 'httppoll') {
                    data_val = res.data.result.items.data[data_key]['data'];
                    data_key = 'HTTP Poll Interval';
                    if (data_val === '120') data_val = '2 Minutes';
                  } else if (data_key === 'activated') {
                    data_val = res.data.result.items.data[data_key] ? 'Activated' : 'Not Activated';
                    data_key = 'SIM Status';
                  } else if (data_key === 'disabled') {
                    data_val = res.data.result.items.data[data_key] ? 'SIM Disabled' : 'SIM Not Disabled';
                    data_key = 'Disabled Status';
                  } else if (data_key === 'transferred') {
                    data_val = res.data.result.items.data[data_key] ? 'OTA transferred' : 'Not transferred';
                    data_key = 'Transferred';
                  } else if (data_key === 'transferred_iccid') {
                    data_val = res.data.result.items.data[data_key];
                    data_key = 'Transferred ICCID';
                    http_data.push({'data_name': data_key, 'data_value': data_val});
                  }

                  //store key
                  if (data_key !== '' && data_val !== '') {
                    data_val = data_val.toString().replace('default', 'Default');
                    http_data.push({'data_name': data_key, 'data_value': data_val});
                    data_val = '';
                  }

                  //Subscription Information table
                  if (data_key === 'iccid') {
                    data_val = res.data.result.items.data[data_key];
                    data_key = 'ICCID';
                  } else if (data_key === 'carrier') {
                    data_val = res.data.result.items.data[data_key];
                    data_key = 'Carrier';
                  } else if (data_key === 'mdn') {
                    data_val = res.data.result.items.data[data_key];
                    data_key = 'MDN';
                  } else if (data_key === 'min') {
                    data_val = res.data.result.items.data[data_key];
                    data_key = 'MIN';
                  } else if (data_key === 'msisdn') {
                    data_val = res.data.result.items.data[data_key];
                    data_key = 'MSISDN';
                  } else if (data_key === 'sipupp') {
                    data_val = res.data.result.items.data[data_key]['data'];
                    data_key = 'EF_SIPUPP';
                  } else if (data_key === 'mipupp') {
                    data_val = res.data.result.items.data[data_key]['data'];
                    data_key = 'EF_MIPUPP';
                  } else if (data_key === 'hrpdupp') {
                    data_val = res.data.result.items.data[data_key]['data'];
                    data_key = 'EF_HRPDUPP';

                  } else if (data_key === 'eprl') {
                    data_type = 'file';
                    data_val = res.data.result.carrier.files[data_key].filter(element => element.name === res.data.result.items.data[data_key])[0];
                    data_key = 'ePRL';
                  } else if (data_key === 'oplmn') {
                    data_type = 'file';
                    data_val = res.data.result.carrier.files[data_key].filter(element => element.name === res.data.result.items.data[data_key])[0];
                    data_key = 'OPLMN';
                  } else if (data_key === 'smsp') {
                    data_type = 'file';
                    data_val = res.data.result.carrier.files[data_key].filter(element => element.name === res.data.result.items.data[data_key])[0];
                    data_key = 'SMSP';
                  } else if (data_key === 'mbi') {
                    data_type = 'file';
                    data_val = res.data.result.carrier.files[data_key].filter(element => element.name === res.data.result.items.data[data_key])[0];
                    data_key = 'MBI';
                  } else if (data_key === 'mbdn') {
                    data_type = 'file';
                    data_val = res.data.result.carrier.files[data_key].filter(element => element.name === res.data.result.items.data[data_key])[0];
                    data_key = 'MBDN';
                  }

                  //console.log({'data_name': data_key, 'data_value': data_val, 'data_type': data_type});
                  //store key
                  if (data_key !== '' && data_val !== '') {
                    //   //if you can find the data_val in the res.data.result.carrier.files[data_key.toLowerCase()]['display_name']
                    //   if (res.data.result.carrier.files.hasOwnProperty(data_key.toLowerCase()) && data_val.toLowerCase() !== 'default') {
                    //     res.data.result.carrier.files[data_key.toLowerCase()].forEach(function (item) {
                    //       let dVal = item.default ? true : false;
                    //       let dName = item.display_name;
                    //       //console.log('val:', dVal, ' name:', dName);
                    //       if (dName.toLowerCase() === data_val.toLowerCase()) {
                    //         if (dVal) data_val = dName + " (Default)";
                    //       }
                    //     });
                    //   } else {
                    //     data_val = data_val.toString().replace('default', 'Default');
                    //   }
                    sub_data.push({'data_name': data_key, 'data_value': data_val, 'data_type': data_type});
                  }
                });

                res.data.result.log_items.forEach(item => {

                  if (item.hasOwnProperty('ota')) {
                    item.ota = item.ota ? 'Activated OTA' : '';
                  }

                  if (item.hasOwnProperty('smsota') && item.smsota) {
                    item.smsota = item.smsota ? 'Activated OTA (SMS)' : '';
                    item.ota = 'Activated OTA (SMS)';
                  }

                  if (item.hasOwnProperty('otareset')) {
                    item.ota = 'Reset defaults';
                  }

                  if (!item.hasOwnProperty('date') && item.hasOwnProperty('start')) {
                    item.date = item.start;
                    item.username = 'system';

                    if (JSON.stringify(item).toLowerCase().includes('error')) {
                      item.ota = 'Provision did not complete';
                    } else {
                      item.ota = 'Provisioned successfully';
                    }
                  }

                });

                // this.fields.splice(this.fields.findIndex(v => v.key === "enabled"), 1);

                // UPDATE/FORAMT each of the log_items
                if (res.data.result.log_items && res.data.result.log_items.length > 0) {
                  res.data.result.log_items.forEach(function (entry, x) {
                    if (entry.items && entry.items.length > 0) {
                      entry.items = entry.items.filter((item, index) => entry.items.indexOf(item) === index);
                      entry.items = entry.items.filter(function (e) {
                        return e !== 'NONE'
                      })
                    }
                    res.data.result.log_items[x] = entry;
                  });
                }

                this.sub_data = sub_data;
                this.http_data = http_data;
                this.key_data = key_data;
                this.log_data = res.data.result.log_items;
                this.profile_data_src = res.data.result;
                this.hasData = true;
              } else {
                this.hasData = false;
                this.sub_data = null;
                this.http_data = null;
                this.key_data = null;
                this.log_data = null;
                this.profile_data_src = null;
              }
            } else {
              this.$toast.warning(res.data.error_string)
            }
          }
      );

      this.submitLoading = false;
    },

    formatObjectData(str) {
      //console.log(str);
      try {
        if (typeof str === "string") {
          return str;
        } else if (typeof str === "object") {
          let arr = Object.entries(str);
          let out = '';
          let cnt = 0;
          Object.entries(str).forEach(entry => {
            cnt++;
            if (out.includes(entry[1]))
              out += cnt + ': ' + entry[1] + ', ';
          });
          out = out.substring(0, out.length - 2);//trim last 2 char
          return out;
        } else {
          return str;
        }
      } catch (e) {
        return str;
      }
    },

    formatStatus(str) {
      str = `${str}`;
      str = str.toLowerCase();
      if (str === 'true') {
        str = 'Activated';
      } else if (str === 'false') {
        str = 'Not Activated';
        // } else if (String(str)) {
        //   str = str.replace('{','').replace('}','');
        // } else {
        //str = txt;
      }
      return str;
    },

    refreshPage() {
      setTimeout(() => {
        this.profile_data_src = null;
        this.loadPageData();
      }, 1000);
    },

    showToasterMsg(message, append = false, variant = 'success') {
      //setup for alert
      this.$toast({
        component: ToastVue,
        props: {
          description: message
        }
      }, {
        type: variant
      })
    },

    clickActivate() {
      this.$router.push({path: `/ota/activate/:?iccid=${this.iccid}`})
    },

    clickReset() {
      this.$root.$emit('loadingPanelShow', true)
      otaDashboardService.reset(this.iccid).then(res => {
        setTimeout(() => {
            this.$root.$emit("loadingPanelHide", true);
          }, 300);
        if (res.data.status === true) {
          this.$toast.success({
            component: ToastVue,
            props: {
              description: 'Successfully Reset'
            }
          })
          this.refreshPage();
        }
      })
    }

  },
}
</script>
